import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import intl from 'react-intl-universal';
import { Link } from 'react-router-dom';
import { Typography, useLink } from '@getsynapse/design-system';
import { resetUser } from 'state/User/userSlice';
import { PATHS } from 'utils/constants';

const DeactivatedAccountPage = () => {
  const dispatch = useDispatch();
  const linkClassName = useLink();

  useEffect(() => {
    dispatch(resetUser());
  }, [dispatch]);

  return (
    <div className='flex flex-col items-center'>
      <Typography variant='h2' className='pb-4'>
        {intl.get('DEACTIVATED_USER_PAGE.TITLE')}
      </Typography>

      <Typography variant='body' className='w-97 pb-8 text-center'>
        {intl.get('DEACTIVATED_USER_PAGE.CAPTION')}
      </Typography>

      <Link to={PATHS.LOGIN} className={linkClassName}>
        {intl.get('DEACTIVATED_USER_PAGE.CTA')}
      </Link>
    </div>
  );
};

export default DeactivatedAccountPage;
